import {
  bindViewportCssVars,
  disableVerticalSwipes,
  expandViewport,
  mountSwipeBehavior,
  mountViewport,
} from "@telegram-apps/sdk-react";
import { subscribeTelegramViewport } from "./telegramViewport";

/**
 * Telegram Mini App chrome that must be configured once at boot:
 * - expand to full height so we are not stuck at the compact (~70%) sheet
 * - keep --app-height in sync as the user pulls the sheet open
 * - disable vertical swipes so dragging UI cannot close the Mini App
 */
export async function setupTelegramMiniApp(): Promise<void> {
  try {
    if (mountViewport.isAvailable()) {
      await mountViewport();
      if (bindViewportCssVars.isAvailable()) {
        bindViewportCssVars();
      }
      if (expandViewport.isAvailable()) {
        expandViewport();
      }
    }
  } catch (error) {
    console.warn("[Telegram] Failed to mount viewport", error);
  }

  try {
    if (mountSwipeBehavior.isAvailable()) {
      mountSwipeBehavior();
      if (disableVerticalSwipes.isAvailable()) {
        disableVerticalSwipes();
      }
    }
  } catch (error) {
    console.warn("[Telegram] Failed to disable vertical swipes", error);
  }

  const webApp = window.Telegram?.WebApp;
  webApp?.ready?.();
  webApp?.expand?.();
  webApp?.disableVerticalSwipes?.();

  subscribeTelegramViewport();
}
